import React, { useState } from "react";
import { connect } from "react-redux";
import axios from "axios";
import notify from "devextreme/ui/notify";
import { FileUploader } from "devextreme-react/file-uploader";
import { Button } from "devextreme-react/button";
import data from "../assets/apiRoutes.json";

const ImportDashboard = (props) => {
    const accessToken = props.oidc.user.access_token;

    const [file, setFile] = useState(null);
    const [importing, setImporting] = useState(false);

    const onFileChanged = (e) => {
        const files = e.value || [];
        setFile(files.length > 0 ? files[0] : null);
    };

    const onImport = async () => {
        if (!file) {
            notify({ message: "Choose a JSON file to import.", width: 320 }, "warning", 2500);
            return;
        }

        const form = new FormData();
        form.append("file", file);

        setImporting(true);
        try {
            const res = await axios.post(
                `${window._env_.REACT_APP_APIS}/${data.DB.ImportDashboards}`,
                form,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );

            const payload = res.data?.resultdata ?? res.data?.Resultdata ?? res.data ?? {};
            const imported = payload.imported ?? 0;
            const skipped = payload.skipped ?? 0;
            const errors = payload.errors ?? [];

            let msg = `Imported ${imported} dashboard(s)`;
            if (skipped > 0) msg += `, skipped ${skipped} (name already exists)`;
            if (errors.length > 0) msg += `, ${errors.length} error(s)`;
            notify(
                { message: msg, width: 420 },
                errors.length > 0 ? "warning" : "success",
                4000
            );
            if (errors.length > 0) console.warn("Import errors:", errors);
        } catch (err) {
            console.error("Import failed", err);
            const serverMsg = err.response?.data;
            notify(
                {
                    message: typeof serverMsg === "string" && serverMsg.length < 200
                        ? serverMsg
                        : "Import failed. See console for details.",
                    width: 420,
                },
                "error",
                4000
            );
        } finally {
            setImporting(false);
        }
    };

    return (
        <div style={{ padding: 20, maxWidth: 720 }}>
            <h6 style={{ color: window._env_.Color2, fontWeight: 700, marginBottom: 20 }}>
                Import Dashboard
            </h6>

            <div style={{ marginBottom: 16 }}>
                <label style={{ display: "block", marginBottom: 6, fontWeight: 600 }}>
                    Select an exported dashboard JSON file
                </label>
                <FileUploader
                    selectButtonText="Choose file"
                    labelText="or drop file here"
                    accept="application/json,.json"
                    multiple={false}
                    uploadMode="useForm"
                    onValueChanged={onFileChanged}
                />
            </div>

            <Button
                text={importing ? "Importing..." : "Import"}
                type="default"
                disabled={importing || !file}
                onClick={onImport}
            />

            <p style={{ marginTop: 24, fontSize: 12, color: "#666" }}>
                Dashboards are added to the current facility. If a dashboard with the same
                name already exists, it is skipped.
            </p>
        </div>
    );
};

function mapStateToProps(state) {
    return { oidc: state.oidc };
}

export default connect(mapStateToProps)(ImportDashboard);
